import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const ImportYandexMarketSetupDeleteContentType = '' as const;
export type ImportYandexMarketSetupDeleteRequest = void;
export type ImportYandexMarketSetupDeleteResponses = LinkCommonErrorResponses & {
    /**
     * @description Yandex Market settings deleted successfully
     */
    '200': {};
};
export type ImportYandexMarketSetupDeleteResponseSuccess = undefined;
export type ImportYandexMarketSetupDeleteSearchParams = undefined;
export type ImportYandexMarketSetupDeletePathParameters = undefined;
export const ImportYandexMarketSetupDeleteUrl = '/integrations/yamarket/setup' as const;
export const ImportYandexMarketSetupDeleteMethod = 'DELETE' as const;
export const getImportYandexMarketSetupDeleteUrl = (_params?: ImportYandexMarketSetupDeletePathParameters) =>
    ImportYandexMarketSetupDeleteUrl;
